import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router';
import { useSearchParams } from 'react-router-dom'
import Card from '../components/card';
import PageFamily from './PageFamily';
import PageSocial from './PageSocial';
import PageAddStore from './PageAddStore';
import PageAddSocialContent from './PageAddSocialContent';
import PageTC from './PageTC';
import PagePrivacy from './PagePrivacy';
import PageSupport from './PageSupport';
import PageProfile from './PageProfile';
import { login } from '../api/account'
import { Alert, Box, LinearProgress } from '@mui/material';
import { BOTTOM_NAVIGATION } from '../config/constant';
import PageAdminUser from './PageAdminUser';
import PageWizard from './PageWizard'
import PageBlog from './PageBlog';
import LoginHome from '../pages/LoginHome';
import WhatsappLoginPage from '../components/homepageuicomponents/whatsappLoginPage';
import { isLoggedIn } from '../api/account';
import WizardAdmin from '../components/wizard/WizardAdmin';
import PageOfferZone from './PageOfferZone';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import DetectPlatform from '../components/detectDevice/DetectPlatform'
// Import components needed for bottom navigation
import PageBoat from './PageBoat';
import PageDelivery from './PageDelivery';
// Import the new BusTabView component
import BusTabView from '../components/busStatus/BusTabView';

const Home = ({ setRefresh, bottomNavigationTab, updateBottomNavigationTab, displayFullScreen, isFullScreen, refreshPage  }) => {

    const query = new URLSearchParams(useLocation().search)
    const [searchParams, setSearchParams] = useSearchParams();

    const page = query.get('page')
    const content = query.get('content')
    const code = query.get('code')
    const activity = query.get('activity')

    const [loginFlow, setLoginFlow] = useState(!!code)

    // const hash = new URLSearchParams(useLocation().hash)
    // const loginFlow = hash.get('token_type')

    useEffect(() => {
        async function loginUser() {
            await login(code, page)
            setLoginFlow(false)
            if (searchParams.has('code')) {
                searchParams.delete('code')
                setSearchParams(searchParams);
            }
            refreshPage()
        }
        if(loginFlow) {
            loginUser()
        }
    }, [loginFlow, page, code, refreshPage])

    if(loginFlow) {
        return (
            <Box sx={{ width: '100%' }}>
                <LinearProgress />
            </Box>
          );
    }

    const user = isLoggedIn()
    const requiresLogin = [BOTTOM_NAVIGATION.USER_PROFILE, BOTTOM_NAVIGATION.ADMIN, BOTTOM_NAVIGATION.WIZARD].includes(bottomNavigationTab);
    if (requiresLogin) {
        if (!user) {
            displayFullScreen(true)
            return (<LoginHome />)
        } else if (user['custom:isMobileVerified'] !== '1') {
            displayFullScreen(true)
            return (<WhatsappLoginPage refreshPage={refreshPage} />)
        }
    }

    if(activity?.startsWith("wizardOrder") && !bottomNavigationTab) {
        if (searchParams.has('activity')) {
            searchParams.delete('activity')
            setSearchParams(searchParams);
        }
        const userOrderId = activity.split("__")[1]
        return (<WizardAdmin userOrderId={userOrderId} oneTimeOrder={true} />)
    }

    switch(bottomNavigationTab) {
        case BOTTOM_NAVIGATION.BUS:
            return (
                <div className={!isFullScreen ? "wrapper" : ''}>
                    <BusTabView 
                        updateBottomNavigationTab={updateBottomNavigationTab} 
                        displayFullScreen={displayFullScreen}
                    />
                </div>)
        case BOTTOM_NAVIGATION.BOAT:
            return (<PageBoat updateBottomNavigationTab={updateBottomNavigationTab} />)
        case BOTTOM_NAVIGATION.OFFER_ZONE:
            return (<PageOfferZone updateBottomNavigationTab={updateBottomNavigationTab} />)
        case BOTTOM_NAVIGATION.DELIVERY:
            return (<PageDelivery updateBottomNavigationTab={updateBottomNavigationTab} />)
        case BOTTOM_NAVIGATION.USER_PROFILE:
            return (<PageProfile />)
        case BOTTOM_NAVIGATION.WIZARD:
            return (<PageWizard />)
        case BOTTOM_NAVIGATION.ADMIN:
            return (<PageAdminUser />)
        default:
            console.log('no bottom navigation selected')
    }

    switch(page) {
        // case 'profile': 
        // return (<PageProfile setRefresh={setRefresh}/>)
        // case 'family': 
        // return (<PageFamily />)
        // case 'social': 
        // return (<PageSocial setRefresh={setRefresh} doAppBarRefresh={loginFlow}/>)
        // case 'delivery': 
        // return (<listOfStores setRefresh={setRefresh} doAppBarRefresh={loginFlow}/>)
        // case 'addStore': 
        // return (<PageAddStore setRefresh={setRefresh} doAppBarRefresh={loginFlow} />)
        // case 'addSocialContent': 
        // return (<PageAddSocialContent setRefresh={setRefresh} doAppBarRefresh={loginFlow} />)
        case 'blog': 
        return (<PageBlog content={content} />)
        case 'tc': 
        return (<PageTC />)
        case 'privacy':
        return (<PagePrivacy />)
        case 'support':
        return (<PageSupport />)
        default: {
        return (
            <div className={!isFullScreen ? "wrapper" : ''}>
                {/* <Alert severity="info">You are now using a Beta version of the Mattool App. The official launch will be announced soon. Please report any issues in the "Ask Mattool" section down below.</Alert> */}
                    {/* <Card 
                img="groceries_small.jpg"
                title="Organic Groceries"
                description="Get home grown groceries."
                type="grocery"
                    /> */}
                {/* <Card 
                title="മാട്ടൂൽ നിവാസികൾക് സ്വാഗതം."
                description="നമ്മുടെ സ്വന്തം മാട്ടൂൽ ആപ്പ് 😊. ബസ് സമയം, ഡെലിവറി എന്നിവ മാട്ടൂൽ ആപ്പിൽ ലഭ്യമാണ്."
                type="wallPost"
                    /> */}
                {/* <div className='card' >
                    <DeliveryInfoCard />
                </div> */}
                <Card 
                img="bus_small.jpg"
                title="Bus Search"
                description="Find buses between any two stops."
                type="searchBus"
                updateBottomNavigationTab={updateBottomNavigationTab}
                displayFullScreen={displayFullScreen}
                    />
                <Card 
                img="bus_small.jpg"
                title="Bus Time Table"
                description="Find Bus timings for each bus stops in Mattool."
                type="showBus"
                updateBottomNavigationTab={updateBottomNavigationTab}
                displayFullScreen={displayFullScreen}
                    />
                <Card 
                title="ADD TO HOMESCREEN"
                type="wallPost"
                    />    
                <Card 
                img="feedback.jpg"
                title="Ask mattool.in"
                type="post"
                    />
                { 
                // TODO : Electricians / plumbers / car rent 
                } 
            </div>
            )
        }
    }
}

export default Home
